import React from 'react';
import _ from 'lodash';
import Container from '../../layout/container/Container';
import CellAbstract from './CellAbstract';
import { CELL_TAG_PROPS } from './Types';

/**
 * Component that should be used inside grid if we want to configure specific column to render lang tags init
 **/
class CellTag extends CellAbstract<CELL_TAG_PROPS, {}> {
  /**
   * Rendering tag or tags
   * @param value string value for cell render content
   * @param isLastTag flag if tag is last one
   **/
  mapTags = (value: string, isLastTag: boolean) => {
    const withArrow = _.get(this.props, 'cellConfig.withArrow', true);
    const showArrowBetweenTags = !isLastTag && withArrow;
    const showLastTagWithDifferentColor = isLastTag && _.get(this.props, 'cellConfig.withLastTagDifferentColor', true);
    return (
      <>
        <span
          key={value}
          className={`tp-tag-cell tp-text-ellipsis${showLastTagWithDifferentColor ? ' tp-tag-last' : ''}`}
        >
          {value}
        </span>
        {showArrowBetweenTags ? <i
          className={`tp-icon ${withArrow ? 'tp-arrow-forward' : 'tp-no-icon'}`}
        /> : null}
      </>
    );
  };

  renderContainer = (value) => {
    let tagsContent = null;
    if (value) {
      let tempValue = _.isArray(value) ? value : [value];
      const keyPrefix = tempValue.join('-');
      tagsContent = tempValue.map((item, index) => (
        <React.Fragment key={keyPrefix + index}>
          {this.mapTags(item, index + 1 === tempValue.length)}
        </React.Fragment>
      ));
    }
    return (
      <Container
        hBox
        alignItemsCenter
        className={'tp-text-ellipsis'}
      >
        {tagsContent}
      </Container>
    );
  }

  render() {
    const {
      dataIndex,
      dataItem,
      field
    } = this.props;

    const value = dataItem[(field || dataIndex)];

    return this.renderCell(this.renderContainer(value));
  }
}

export default CellTag;
